import { render, staticRenderFns } from "./RepresentacaoConjuntoListDados.vue?vue&type=template&id=3be66f3e"
import script from "./RepresentacaoConjuntoListDados.vue?vue&type=script&lang=js"
export * from "./RepresentacaoConjuntoListDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports